/* globals  lp, editor */
var InvariantsHelper = require('./invariants-helper');
var jQuery = require('jquery');
var _ = require('lodash');

(function() {
  var assert = lp.invariants.assert,
    register = lp.invariants.register,
    helper = InvariantsHelper;

  var _checkAdvancedProperties = function(elmId, elmType) {
    var $propertiesPanel = jQuery(helper.panelSelectorMapping.properties);
    var $advancedProps = $propertiesPanel.find(".collapsible-panel .panel-content:last input");
    if ($advancedProps.length === 0) {
      // another tab is currently displayed
      return true;
    } else {
      return _.isEmpty(
        _.difference(
          ['#' + elmId, '.' + elmType],
          _.map($advancedProps, function(elm) {
            return jQuery(elm).attr('value');
          })
        )
      );
    }
  };

  register('CheckAdvancedProperties', function() {
    if(helper.isPagePropertiesTabEnabled()) {
      return assert(_checkAdvancedProperties('lp-pom-root', 'lp-pom-root'), "Advanced properties are not properly set for root element");
    } else if (helper.isNonRootElementSelectedAndPropertiesPanelVisible()) {
      return assert(_checkAdvancedProperties(editor.activeElement.id, editor.activeElement.type), "Advanced properties are not properly set for active element");
    } else {
      return true;
    }
  });
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/invariants/advanced-properties-panel-invariants.js
// module id = 1073
// module chunks = 0